import PropTypes from "prop-types";
import React from "react";

import { StyleSheet, Text } from "react-native";
import { connect } from "react-redux";

import fonts from "../constants/fonts";
import staticColors from "../constants/staticColors";

class DoctorField extends React.Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  };

  render() {
    const { label, themeColors, value } = this.props;

    return (
      <>
        <Text style={[styles.label, { color: themeColors.primary }]}>
          {label.toUpperCase()}
        </Text>
        <Text style={styles.value}>{value}</Text>
      </>
    );
  }
}

const styles = StyleSheet.create({
  label: {
    fontSize: 15,

    ...fonts.bold
  },
  value: {
    color: staticColors.grey,
    fontSize: 15,
    marginBottom: 25,

    ...fonts.regular
  }
});

export default connect(state => ({
  themeColors: state.themeColors
}))(DoctorField);
